import { connect } from 'react-redux';
import SignUp from '../../../components/SignUp';

import {
  createUser,
  resetRegistrationState,
} from '@xanadu/ui-shared/modules/userRegistration/actions';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';

import { displayBrandFeedback } from '@xanadu/ui-shared/modules/userRegistration/actions';

const mapDispatchToProps = {
  resetRegistrationState,
  createUser,
  displayModal,
  displayBrandFeedback,
};

function mapStateToProps(state) {
  const promoRegistrationImage = state.getIn(['modal', 'extraData', 'promoRegistrationImage']);

  return {
    registrationErrors: state.getIn(['user', 'registrationErrors']),
    registrationLoading: state.getIn(['user', 'registrationLoading']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    countries: state.getIn(['lookups', 'countries']),
    isFeedbackAlreadyTriggered: state.getIn(['feedback', 'triggeredOnce']),
    regFeedbackEnabled: state.getIn(['application', 'regFeedbackEnabled']),
    currencies: state.getIn(['lookups', 'currencies']),
    securityQuestions: state.getIn(['lookups', 'securityQuestions']),
    joinNowImage: state.getIn(['application', 'joinNowImage']),
    joinNowImageZero: state.getIn(['application', 'joinNowImageZero']),
    joinNowImageCasino: state.getIn(['application', 'joinNowImageCasino']),
    joinNowImageLiveCasino: state.getIn(['application', 'joinNowImageLiveCasino']),
    joinNowImageVirtuals: state.getIn(['application', 'joinNowImageVirtuals']),
    joinNowImageVegas: state.getIn(['application', 'joinNowImageVegas']),
    termsConditionsUrl: state.getIn(['application', 'registrationTermsConditionsUrl']),
    widthSize: state.getIn(['application', 'widthSize']),
    product: state.getIn(['application', 'product']),
    promoRegistrationImage,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
